import React from "react";

import Counter from "./Counter";

// NonResidentTicketOptions component (shows the non-resident-priced ticket counters)
const NonResidentTicketOptions = (props) => {
    const {isWAResident, isMember, maxTickets, todaysTicketData, seats, selectedTimeIndex, selectedTickets, setSelectedTickets} = props;

    const AdultPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Adult');
    const YouthPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Youth');
    const ChildPrice = todaysTicketData[selectedTimeIndex].prices.filter(price => price.applies_to === 'Child');

    const getInputLimit = (targetKey) => {
        const allKeys = ["Adult", "Youth", "Child"];
        let inputLimit = isMember ? seats.member.available : seats.general.available;

        if(maxTickets) {
            inputLimit = Math.min(inputLimit, maxTickets);
        }

        for(const key of allKeys) {
            if(key !== targetKey) {
                inputLimit -= selectedTickets[key];
            }
        }

        return inputLimit;
    };

    return (
        <>
            {((isWAResident.isResident && isWAResident.isConfirmed) || isMember) && <h5 className="guest-ticket-selector__heading">Non-Resident Tickets</h5>}
            <div className="guest-ticket-selector__option">
                <h6 className="guest-ticket-selector__title">Adult</h6>
                <p className="guest-ticket-selector__description"><small>Ages 13 & over</small></p>
                <p className="guest-ticket-selector__price">${AdultPrice.length > 0 && AdultPrice[0].price.toFixed(2)}</p>
                <Counter
                    valueKey="Adult"
                    valueObject={selectedTickets}
                    setValue={setSelectedTickets}
                    inputLimit={getInputLimit("Adult")}
                />
            </div>
            <div className="guest-ticket-selector__option">
                <h6 className="guest-ticket-selector__title">Youth</h6>
                <p className="guest-ticket-selector__description"><small>Ages 4 - 12</small></p>
                <p className="guest-ticket-selector__price">${YouthPrice.length > 0 && YouthPrice[0].price.toFixed(2)}</p>
                <Counter
                    valueKey="Youth"
                    valueObject={selectedTickets}
                    setValue={setSelectedTickets}
                    inputLimit={getInputLimit("Youth")}
                />
            </div>
            <div className="guest-ticket-selector__option">
                <h6 className="guest-ticket-selector__title">Child</h6>
                <p className="guest-ticket-selector__description"><small>Ages 3 & under</small></p>
                <p className="guest-ticket-selector__price">{ChildPrice.length > 0 && (ChildPrice[0].price == 0 ? 'Free' : '$' + ChildPrice[0].price.toFixed(2))}</p>
                <Counter
                    valueKey="Child"
                    valueObject={selectedTickets}
                    setValue={setSelectedTickets}
                    inputLimit={getInputLimit("Child")}
                />
            </div>
        </>
    )
}

export default NonResidentTicketOptions;